<div mat-dialog class="bg-light-light rounded p-10" [attr.aria-hidden]="false">
	<div class="d-flex align-items-center justify-content-start">
		<div class="symbol symbol-circle d-flex justify-content-center align-items-center symbol-50px">
			<span class="round symbol-label font-size-h5 fw-bold text-primary">
				<app-keenicon name="trash" class="fs-1 text-danger"></app-keenicon>
			</span>
		</div>
		<div class="d-flex flex-wrap justify-content-start flex-row ms-4">
			<h3 class="fw-bolder text-dark-dark m-0" [translate]="'you_are_about_to_delete'" [translateParams]="{ typeTitle: typeTitle, itemName: itemName }">you_are_about_to_delete</h3>
		</div>
	</div>

	<div class="mt-6">
		<span class="" translate>once_deleted</span>
		@if (msg) {
			<span class="ms-1" translate>{{ msg }}</span>
		}
		<span class="ms-1" translate>are_you_sure</span>
	</div>
	<div class="d-flex justify-content-between mt-10">
		<button type="button" (click)="cancelDelete()" class="btn btn-light font-weight-bolder px-9 py-4" translate>cancel</button>
		<button type="button" (click)="deleteConfirm()" class="d-flex align-items-center justify-content-center btn btn-primary btn-hover-primary font-weight-bolder px-9 py-4" translate>
			i_want_to_delete
			<app-keenicon name="like" class="fs-2 text-white ms-2 mb-1"></app-keenicon>
		</button>
	</div>
</div>
